import React, { createContext, useContext, useState, ReactNode } from "react";

interface NavbarOfferData {
  title?: string;
  companyName?: string;
  url?: string;
  isArchived?: boolean;
}

interface NavbarOfferContextType {
  offerData: NavbarOfferData;
  setOfferData: (data: NavbarOfferData) => void;
}

const NavbarOfferContext = createContext<NavbarOfferContextType | undefined>(
  undefined
);

export function NavbarOfferProvider({ children }: { children: ReactNode }) {
  const [offerData, setOfferData] = useState<NavbarOfferData>({});

  return (
    <NavbarOfferContext.Provider value={{ offerData, setOfferData }}>
      {children}
    </NavbarOfferContext.Provider>
  );
}

export function useNavbarOffer() {
  const context = useContext(NavbarOfferContext);
  if (context === undefined) {
    throw new Error("useNavbarOffer must be used within NavbarOfferProvider");
  }
  return context;
}
